import React, { useEffect, useState } from "react";
import "./channelMember.css";
import AdminMember from "./Member_Container/AdminMember";
import IndividualsMember from "./Member_Container/IndividualsMember";
import GroupsMember from "./Member_Container/GroupsMember";
import axios from "../../../../axios";
import IndividualsMemberForStudents from "./Member_Container/IndividualsMemberForStudents";
import AddMemebers from "../../Create_channel_screen/AddMemebers";
import CreateSuccessfulChannel from "../../Create_successful/CreateSuccessfulChannel";
import SaveChangesConfirm from "./SaveChangesConfirm";
import { useSelector } from "react-redux";

const ChannelMember = ({ community, setIsMemberUpdated, isMemberUpdated }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [inEditingMode, setInEditingMode] = useState(false);
  const [inAddingMode, setInAddingMode] = useState(false);
  const [allMembers, setAllMembers] = useState({
    admins: [],
    teachers: [],
    students: [],
  });
  const { admins, teachers, students } = allMembers;
  const [openSuccessful, setOpenSuccessfull] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [editingAllMembersDetails, setEditingAllMembersDetails] = useState([]);
  const [deletingAllMembersDetails, setDeletingAllMembersDetails] = useState({
    deletingStudents: [],
    deletingTeachers: [],
    deletingGroups: [],
    deletingAdmins: [],
  });
  const { deletingStudents, deletingTeachers, deletingGroups, deletingAdmins } =
    deletingAllMembersDetails;

  useEffect(() => {
    try {
      const getMember = async () => {
        let res = await axios.get(`/community/${community?.id}/getMember`);
        let admins = [];
        let teachers = [];
        let students = [];

        for (const member of res.data.data.members) {
          if (member.admins_id && member.admins_id.length > 0) {
            admins.push(...member.admins_id);
          }
          if (member.teachers_id && member.teachers_id.length > 0) {
            teachers.push(...member.teachers_id);
          }
          if (member.students_id && member.students_id.length > 0) {
            students.push(...member.students_id);
          }
        }

        setAllMembers({
          ...allMembers,
          admins: admins,
          teachers: teachers,
          students: students,
        });
      };
      getMember();
    } catch (error) {
      console.log(error);

    }
  }, []);
  return (
    <>
      {!openSuccessful ? (
        <>
          {admins.length > 0 || teachers.length > 0 || students.length > 0 ? (
            <div className="d-flex flex-column">
              <div className="w-100">
                <div className="request_member_box pb-3 mt-2">
                  {admins?.length > 0 &&
                    [...admins]
                      .sort((a, b) =>
                        a.admin.id === currentUser?.id
                          ? -1
                          : b.admin.id === currentUser?.id
                            ? 1
                            : a.admin.id === community?.user_id?.id
                              ? -1
                              : b.admin.id === community?.user_id?.id
                                ? 1
                                : 0
                      )
                      .map((admin, index) => (
                        <AdminMember
                          inEditingMode={inEditingMode}
                          setEditingAllMembersDetails={
                            setEditingAllMembersDetails
                          }
                          creatorId={community?.user_id?.id}
                          editingAllMembersDetails={editingAllMembersDetails}
                          setDeletingAllMembersDetails={
                            setDeletingAllMembersDetails
                          }
                          deletingAllMembersDetails={deletingAllMembersDetails}
                          key={index}
                          admin={admin}
                        />
                      ))}
                  {/* </div> */}
                  {/* <div className="members_heading py-3">MEMBERS</div> */}
                  {admins?.length > 0 && <div className="members_heading py-2 ms-4">Member</div>}
                  <div className="ml-4">
                    {teachers?.length > 0 && <div className="members_heading py-2 ms-4">Teachers</div>}
                    {(teachers?.length > 0 || students?.length > 0) && (
                      <>
                        {/* <div className="members_heading py-1 ms-4">Individuals</div> */}
                        <div className="ml-4 p-0 indivisual_box">
                          {teachers?.length > 0 &&
                            [...teachers]
                              .sort((a, b) =>
                                a.teacher.id === currentUser?.id
                                  ? -1
                                  : b.teacher.id === currentUser?.id
                                    ? 1
                                    : a.role === "moderator"
                                      ? -1
                                      : b.role === "moderator"
                                        ? 1
                                        : 0
                              )
                              .map((teacher, index) => (
                                <IndividualsMember
                                  setEditingAllMembersDetails={
                                    setEditingAllMembersDetails
                                  }
                                  editingAllMembersDetails={
                                    editingAllMembersDetails
                                  }
                                  inEditingMode={inEditingMode}
                                  setDeletingAllMembersDetails={
                                    setDeletingAllMembersDetails
                                  }
                                  deletingAllMembersDetails={
                                    deletingAllMembersDetails
                                  }
                                  key={index}
                                  teacher={teacher}
                                />
                              ))}
                        </div>
                        <div className="mt-2">
                          {students?.length > 0 && <div className="members_heading py-2 ms-4">Students</div>}
                          <div className="ml-3">
                            {students?.length > 0 &&
                              students.map((student, index) => (
                                <IndividualsMemberForStudents
                                  inEditingMode={inEditingMode}
                                  setDeletingAllMembersDetails={
                                    setDeletingAllMembersDetails
                                  }
                                  deletingAllMembersDetails={
                                    deletingAllMembersDetails
                                  }
                                  key={index}
                                  student={student}
                                />
                              ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {community?.groups?.length > 0 && <div className="members_heading py-2 ms-4">Groups</div>}
                  <div className="col-11 p-0 ms-4 indivisual_box">
                    {community?.groups?.length > 0 &&
                      community?.groups?.map((group, index) => (
                        <GroupsMember
                          key={index}
                          setDeletingAllMembersDetails={
                            setDeletingAllMembersDetails
                          }
                          deletingAllMembersDetails={deletingAllMembersDetails}
                          inEditingMode={inEditingMode}
                          group={group}
                          communityId={community?.id}
                        />
                      ))}
                  </div>
                </div>
              </div>
              {inAddingMode && (
                <div className="create_channel_transprant_body">
                  <div className="create_channel_container">
                    <img
                      src="/images/cross-circle3.svg"
                      className="channel_crossArrow"
                      alt=""
                      onClick={() => setInAddingMode(!inAddingMode)}
                    />
                    <div className="p-4">
                      <AddMemebers
                        isAddingModel={inAddingMode}
                        setOpenSuccessfull={setOpenSuccessfull}
                        // setChannel={setChannel}
                        setInAddingMode={setInAddingMode}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="loader_container">
              <img
                className="request_post_loader"
                src="/gif/LoaderDot.gif"
                alt=""
              />
            </div>
          )}

          {confirm && (
            <SaveChangesConfirm
              deletingAllMembersDetails={deletingAllMembersDetails}
              setConfirm={setConfirm}
              editingAllMembersDetails={editingAllMembersDetails}
              setIsMemberUpdated={setIsMemberUpdated}
              isMemberUpdated={isMemberUpdated}
              community={community}
            />
          )}
        </>
      ) : (
        <>
          <CreateSuccessfulChannel />
        </>
      )}
    </>
  );
};

export default ChannelMember;
